import React from "react";
import PropTypes from "prop-types";

// One labelled fact inside the Overview card: icon, label, value. Two per row from small up, stacked
// below. A WET copy of products/show/detail_tile.jsx's identical primitive — a second consumer
// doesn't earn promoting it into profiles/; extract it there only once a third consumer needs it,
// per the codebase's own duplicate-twice-before-abstracting rule.
function DetailTile({ icon, label, children }) {
  return (
    <div className="col-12 col-sm-6 mb-3">
      <div className="d-flex">
        <i className={`${icon} text-muted mt-1 me-2`} />
        <div className="flex-grow-1 overflow-hidden">
          <div className="text-muted small">{label}</div>
          <div className="fw-semibold text-break">{children}</div>
        </div>
      </div>
    </div>
  );
}

DetailTile.propTypes = {
  icon: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

export default DetailTile;
